import styled, { css } from 'styled-components';

import { Grid } from '../../micros/Layout/Grid/styles';
import { RowSpan } from '../../micros/Layout/RowSpan/styles';

import { ShortcutHomeProps } from './types';

export const Section = styled(Grid)`
	${({ theme }) => css`
		margin-bottom: 4rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			margin-bottom: 6.4rem;
		}
	`}
`;

export const Container = styled(RowSpan)``;

export const Title = styled.h2<Partial<ShortcutHomeProps>>`
	${({ theme, darkMode }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.medium};
		font-size: ${theme.font.sizes.large};
		line-height: 2.2rem;
		color: ${darkMode ? theme.colors['offWhite'] : theme.colors['black75']};

		margin-bottom: ${theme.spacings.large};

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			font-size: ${theme.font.sizes.big};
			line-height: 4rem;
		}
	`}
`;

export const List = styled(Grid)`
	list-style: none;
	width: 100%;
	margin: 0;
`;

export const Item = styled(RowSpan)`
	min-width: 12rem;
	margin: 0;
`;

export const ModalContent = styled.div<Partial<ShortcutHomeProps>>`
	text-align: center;

	${({ theme, darkMode }) => css`
		${darkMode && { color: `${theme.colors['offWhite']} !important` }}
	`}
`;
export const Text = styled.h4`
	${({ theme }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.medium};
		font-size: ${theme.font.sizes.large};
		line-height: 3.2rem;
		text-align: center;
		color: ${theme.colors.black75};
		margin: 1.6rem 0 0.4rem;
	`}
`;
export const SubText = styled.span`
	${({ theme }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-size: ${theme.font.sizes.large};
		font-weight: ${theme.font.weight.bold};
		line-height: 2.8rem;
		text-align: center;
		color: ${theme.colors.black75};
		margin-bottom: 1.6rem;
	`}
`;
export const Box = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-direction: column;
		gap: ${theme.spacings.medium};
		justify-content: space-between;
		margin-top: 1.6rem;

		a {
			width: calc(50% - ${theme.spacings.medium});
			max-height: 4rem;
			min-width: 8rem;
			min-height: 3.4rem;
			img {
				max-width: 100%;
				max-height: 100%;
				height: 100%;
			}
			:focus {
				outline: 2px solid #000;
			}
		}

		button {
			padding: 0.4rem;
			span:first-child {
				margin-top: 2px;
			}
			span {
				font-weight: ${theme.font.weight.semibold};
			}
		}
	`}
`;

export const Exit = styled.button`
	position: absolute;
	top: 24px;
	right: 16px;
	background-color: transparent;
	border: none;
	cursor: pointer;

	:focus {
		outline: 2px solid #000;
	}
`;

export const ModalStyles = {
	overlay: {
		padding: '0',
		backgroundColor: 'rgba(0,0,0,0.75)',
		inset: '-30px',
	},
	content: {
		margin: 'auto',
		maxWidth: '327px',
		minHeight: '320px',
		height: 'fit-content',
		borderRadius: '8px',
		padding: '68px 32px 48px',
	},
};
